import { useContext, type FC } from 'react';
import { Box, alpha, lighten, useTheme, IconButton, Stack, Tooltip, styled } from '@mui/material';
import { Outlet } from 'react-router-dom';
import MenuTwoToneIcon from '@mui/icons-material/MenuTwoTone';
import Sidebar from './Sidebar';
import { SidebarContext } from 'src/context/SidebarContext';
import appConfig from 'src/config/appConfig';

const SideBarContainerWrapper = styled(Stack)(({ theme }) => ({
  flex: 1,
  height: '100%',
  minHeight: '100vh',
  '.MuiPageTitle-wrapper': {
    background: theme.colors.alpha.white[50],
    marginBottom: theme.spacing(4),
    boxShadow: `0px 2px 4px -3px ${alpha(theme.colors.alpha.black[100], 0.1)}, 0px 5px 12px -4px ${alpha(theme.colors.alpha.black[100], 0.05)}`,
  },
}));

const SidebarLayout: FC = () => {
  const theme = useTheme();
  const { toggleSidebar } = useContext(SidebarContext);

  const mainContentStyles = {
    // position: 'relative',
    zIndex: 5,
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    [theme.breakpoints.up(appConfig.breakMobileView)]: {
      ml: theme.sidebar.width,
    },
  };

  const menuButtonStyles = {
    backgroundColor: alpha(theme.palette.background.paper, 0.9),
    backdropFilter: 'blur(10px)',
    boxShadow: `0 2px 8px ${alpha(theme.palette.common.black, 0.1)}`,
    '&:hover': {
      backgroundColor: theme.palette.background.paper,
      boxShadow: `0 4px 16px ${alpha(theme.palette.common.black, 0.15)}`,
    },
  };

  return (
    <SideBarContainerWrapper>
      <Sidebar />
      <Box sx={mainContentStyles}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Box sx={{ display: { xs: 'block', [appConfig.breakMobileView]: 'none' } }}>
            <Tooltip arrow title='Open Menu'>
              <IconButton color='primary' onClick={toggleSidebar} sx={menuButtonStyles}>
                <MenuTwoToneIcon fontSize='small' />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
        <Outlet />
      </Box>
    </SideBarContainerWrapper>
  );
};

export default SidebarLayout;
